import React, { ReactNode, createContext, useContext, useMemo } from 'react';

interface SidebarContextProps {
    isCollapsed: boolean;
    onToggleIsCollapsed: () => void;
}

const SidebarCollapsedContext = createContext<SidebarContextProps>({
    isCollapsed: false,
    onToggleIsCollapsed: () => {},
});

export const SidebarCollapsedStateProvider = function SidebarCollapsedProvider({
    children,
    isCollapsed,
    onToggleIsCollapsed,
}: {
    children: ReactNode;
    isCollapsed: boolean;
    onToggleIsCollapsed: () => void;
}) {
    const providerValue = useMemo(
        () => ({
            isCollapsed,
            onToggleIsCollapsed,
        }),
        [isCollapsed, onToggleIsCollapsed],
    );
    return <SidebarCollapsedContext.Provider value={providerValue}>{children}</SidebarCollapsedContext.Provider>;
};

export function useSidebarCollapsedState() {
    return useContext(SidebarCollapsedContext);
}
